export const getScoreBarColor = (score: number): string => {
    if (score >= 8) return '#08AC81'
    if (score >= 6) return '#F59E0B'
    return '#FF484B'
}
